module.exports = __webpack_public_path__ + "img/failed.1d51becd.png";